import { loginByMobile, sendSmsCode, sso, logout } from '@/api/login'
import { gps } from '@/utils/tools'
import Store from 'store'
import MD5 from 'md5.js'

const actions = {
    loginByMobile({ commit }, payload) {
        return loginByMobile(payload).then((data) => {
            commit('SET_USERNAME', payload.mobile)
            commit('SET_TOKEN', data.access_key)
            commit('SET_USERID', data.juhsId)
                // 初始化数据
            commit('RESET_APPLY')
            commit('RESET_BANK')
            commit('RESET_COUPON')
            commit('RESET_LOAN')
            commit('RESET_QUOTA')
            commit('RESET_REPAY')
            commit('RESET_USER')
            return Promise.resolve(data)
        })
    },
    sendSmsCode({ commit }, payload) {
        commit('SET_USERNAME', '')
        return sendSmsCode(payload)
    },
    getToken({ commit }, payload) {
        commit('SET_TOKEN', '')
        return sso(payload).then(data => {
            commit('SET_TOKEN', data.accessKey)
            return Promise.resolve()
        })
    },
    gps({ commit }) {
        gps(window).then(data => {
            commit('SET_APPLY', {
                lat: data.lat,
                lng: data.lng
            })
            return Promise.resolve()
        })
    },
    logout({ commit }) {
        logout().then(() => {
            commit('SET_TOKEN', '')
            commit('SET_USERNAME', '')
            return Promise.resolve()
        })
    }
}
const mutations = {
    'SET_TOKEN' (state, payload) {
        state.token = payload
        Store.set('token', payload)

        if (state.token) {
            state.tokenMD5 = new MD5().update(payload).digest('hex')
            Store.set('tokenMD5', state.tokenMD5)
        } else {
            Store.set('tokenMD5', '')
        }
    },
    'SET_TOKEN_BY_STORE' (state, payload) {
        if (state.token !== payload) {
            state.token = payload
            Store.set('token', payload)

            if (state.token) {
                state.tokenMD5 = new MD5().update(state.token).digest('hex')
                Store.set('tokenMD5', state.tokenMD5)
            } else {
                Store.set('tokenMD5', '')
            }
        }
    },
    'SET_USERNAME' (state, payload) {
        state.username = payload
        Store.set('username', payload)
    }
}

const state = {
    token: '',
    tokenMD5: '',
    username: ''
}
export default {
    state,
    mutations,
    actions
}